import { CameraControls, KeyboardControls } from '@react-three/drei';
import { useMemo, useRef } from 'react';
import { Roy } from './models/roy';
import BVHEcctrl, {
  useEcctrlStore,
  type BVHEcctrlApi,
  type StoreState,
} from 'bvhecctrl';
import { useFrame } from '@react-three/fiber';

export const Controllers = () => {
  const camControlRef = useRef<CameraControls>(null!);

  const ecctrlRef = useRef<BVHEcctrlApi | null>(null);

  const colliderMeshesArray = useEcctrlStore(
    (state: StoreState) => state.colliderMeshesArray
  );

  const keyboardMap = useMemo(
    () => [
      { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
      { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
      { name: 'leftward', keys: ['ArrowLeft', 'KeyA'] },
      { name: 'rightward', keys: ['ArrowRight', 'KeyD'] },
    ],
    []
  );

  useFrame(() => {
    // Camera follow character pos
    if (ecctrlRef.current && ecctrlRef.current.group && camControlRef.current)
      camControlRef.current.moveTo(
        ecctrlRef.current.group.position.x,
        ecctrlRef.current.group.position.y + 0.3,
        ecctrlRef.current.group.position.z,
        true
      );
  });

  return (
    <>
      <CameraControls
        ref={camControlRef}
        colliderMeshes={colliderMeshesArray}
        smoothTime={0.1}
        makeDefault
      />

      <KeyboardControls map={keyboardMap}>
        <BVHEcctrl position={[0, 5, 0]} scale={2} ref={ecctrlRef}>
          <Roy position-y={-0.4} />
        </BVHEcctrl>
      </KeyboardControls>
    </>
  );
};
